export default `
  {
    profile {
      showReportImportTooltipUntil
    }
  }
`;